/* Заставка входа в мир: ночное небо с лучами, голем гильдии дышит и покачивается в фиолетовой ауре, искры поднимаются;
   внизу — полоса загрузки в рамке U1 владельца. Поверх всего (и панели вкладок), тает за 0.45 с. */
.splash { position: fixed; inset: 0; z-index: 1000; display: flex; flex-direction: column; align-items: center; justify-content: center;
  gap: var(--space-6); padding: var(--space-6) var(--space-4) calc(var(--space-6) + env(safe-area-inset-bottom));
  background: radial-gradient(ellipse at 50% 42%, #3b2a6e 0%, #1a1438 45%, #0b0a1a 100%); overflow: hidden;
  font-family: 'Lilita One', var(--font-ui); transition: opacity 0.45s ease-out; }
.fade { opacity: 0; pointer-events: none; }

/* медленно вращающиеся лучи за големом */
.rays { position: absolute; left: 50%; top: 42%; width: 160vmax; height: 160vmax; margin: -80vmax 0 0 -80vmax; opacity: 0.22;
  background: repeating-conic-gradient(from 0deg, rgba(180, 140, 255, 0.55) 0deg 6deg, transparent 6deg 22deg);
  mask-image: radial-gradient(circle, #000 0, transparent 45%); -webkit-mask-image: radial-gradient(circle, #000 0, transparent 45%);
  animation: spin 40s linear infinite; }
@keyframes spin { to { transform: rotate(360deg); } }

.stage { position: relative; width: min(78vw, 320px); aspect-ratio: 1; display: grid; place-items: end center; }
.aura { position: absolute; inset: 12% 8% 10%; border-radius: 50%; filter: blur(28px);
  background: radial-gradient(circle, rgba(170, 90, 255, 0.85), rgba(110, 60, 220, 0.35) 55%, transparent 72%);
  animation: aura 2.2s ease-in-out infinite alternate; }
@keyframes aura { from { opacity: 0.55; transform: scale(0.94); } to { opacity: 1; transform: scale(1.06); } }

.golem { position: relative; z-index: 1; width: 100%; height: auto; transform-origin: 50% 100%; pointer-events: none; user-select: none;
  filter: drop-shadow(0 10px 18px rgba(0, 0, 0, 0.55)); animation: golem 2.6s ease-in-out infinite; }
/* дыхание + лёгкое покачивание: живой, но тяжёлый */
@keyframes golem {
  0%, 100% { transform: translateY(0) rotate(-1.2deg) scale(1, 1); }
  25% { transform: translateY(-6px) rotate(0deg) scale(1.015, 0.99); }
  50% { transform: translateY(-2px) rotate(1.2deg) scale(1, 1.012); }
  75% { transform: translateY(-7px) rotate(0deg) scale(0.99, 1.015); }
}
.shadow { position: absolute; bottom: -2%; left: 22%; right: 22%; height: 9%; border-radius: 50%;
  background: radial-gradient(closest-side, rgba(0, 0, 0, 0.6), transparent); animation: shadow 2.6s ease-in-out infinite; }
@keyframes shadow { 25%, 75% { transform: scale(0.9); opacity: 0.75; } }

.spark { position: absolute; bottom: 10%; z-index: 2; width: 6px; height: 6px; border-radius: 50%; opacity: 0;
  background: radial-gradient(circle, #fff, #c9a2ff 45%, transparent 70%); animation: spark 3s ease-in infinite; }
@keyframes spark { 0% { transform: translateY(0) scale(0.6); opacity: 0; } 15% { opacity: 1; } 100% { transform: translateY(-260px) scale(1.2); opacity: 0; } }

.bottom { position: relative; z-index: 1; width: min(88vw, 360px); display: flex; flex-direction: column; align-items: center; gap: var(--space-3); }
.title { color: #f3e6ff; font-size: 22px; letter-spacing: 0.4px; text-shadow: 0 2px 0 #2a1650, 0 0 12px rgba(170, 90, 255, 0.6);
  animation: title 1.6s ease-in-out infinite alternate; }
@keyframes title { from { opacity: 0.75; } to { opacity: 1; } }
/* полоса — в рамке владельца (U1, 640×161: гнездо до x 160 справа колпак 40); заливка — в желобе */
.bar { position: relative; width: 100%; height: 50px; border-style: solid; border-width: 0;
  border-image: url('../../assets/world/art/ui_bar_frame.webp') 0 40 0 160 fill / 0 12px 0 50px stretch; }
.fill { position: absolute; left: 50px; top: 18px; bottom: 17px; width: calc((100% - 62px) * var(--p, 0)); border-radius: 6px;
  background: linear-gradient(180deg, #ffe27a, #e0a21b); box-shadow: inset 0 2px 0 rgba(255, 255, 255, 0.5), 0 0 10px rgba(255, 200, 60, 0.6);
  transition: width 0.4s ease-out; }
.fill::after { content: ''; position: absolute; inset: 0; border-radius: inherit;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.55), transparent) 0 0 / 40% 100% no-repeat; animation: shine 1.3s linear infinite; }
@keyframes shine { from { background-position: -60% 0; } to { background-position: 160% 0; } }

/* гнездо рамки при высоте 50 (×0.31): центр (25, 25) */
.coin { position: absolute; left: 10px; top: 10px; width: 30px; height: 30px; z-index: 1; animation: coin 1.4s linear infinite; }
@keyframes coin { from { transform: rotateY(0deg); } to { transform: rotateY(360deg); } }

@media (prefers-reduced-motion: reduce) {
  .rays, .aura, .golem, .shadow, .spark, .title, .fill::after, .coin { animation: none; }
}
